import { alpha, styled } from '@mui/material/styles';

export const ImageCounterContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  alignSelf: 'center',
  backdropFilter: 'blur(4px)',
  backgroundColor: alpha(theme.palette.background.default, 0.7),
  borderRadius: theme.spacing(2),
  bottom: 0,
  display: 'flex',
  gap: theme.spacing(2),
  justifyContent: 'center',
  padding: theme.spacing(1),
  position: 'fixed',
  width: '100%',
  zIndex: theme.zIndex.appBar,
}));

export const ImageCounterOverlay = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.neutral?.main, 0.66),
  borderRadius: theme.spacing(2),
  bottom: 0,
  margin: theme.spacing(2),
  padding: theme.spacing(2),
  position: 'absolute',
  right: 0,
}));

export const CarouselItemContainer = styled('div')<{
  useSwipeControls?: boolean;
}>(({ useSwipeControls, theme }) => ({
  alignItems: 'flex-start',
  alignSelf: 'center',
  display: 'flex',
  justifyContent: 'center',
  touchAction: useSwipeControls ? 'manipulation' : 'none',
  userSelect: 'none',
  width: '100%',
}));
